import axios from 'axios'

const baseUrl = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:8000'
    }
    if (process.env.NODE_ENV === 'test') {
        return 'http://test:test'
    }
    console.log(window.location.origin)
    return window.location.origin
}

axios.defaults.baseURL = baseUrl()
axios.defaults.withCredentials = true
axios.defaults.headers.common['Content-Type'] = 'application/json'

export default axios
